(function(){
  var cardObserver;

  function emit(eventName, card, extra){
    if (!window.AVAnalytics || typeof window.AVAnalytics.custom !== 'function') return;
    var payload = Object.assign({
      source: document.body && document.body.dataset.pageType || 'storefront',
      product_id: card && card.getAttribute('data-product-id'),
      product_handle: card && card.getAttribute('data-product-handle'),
      list_context: card && card.getAttribute('data-item-list-id'),
      world: card && card.getAttribute('data-au-world'),
      card_position: card && card.getAttribute('data-item-index')
    }, extra || {});
    window.AVAnalytics.custom(eventName, payload, {
      dedupeKey: eventName + ':' + (payload.product_id || payload.product_handle || location.pathname),
      ttl: eventName === 'product_card_viewed' ? 30000 : 800
    });
  }

  function observeCard(card){
    if (!('IntersectionObserver' in window)) {
      emit('product_card_viewed', card);
      emit('au_product_card_view', card, { interaction_type: 'impression' });
      return;
    }
    if (!cardObserver) {
      cardObserver = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if (!entry.isIntersecting) return;
          emit('product_card_viewed', entry.target);
          emit('au_product_card_view', entry.target, { interaction_type: 'impression' });
          cardObserver.unobserve(entry.target);
        });
      }, { threshold: 0.45 });
    }
    cardObserver.observe(card);
  }

  function getRoot(){
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
  }

  function syncCartAccessibleName(event){
    var count = Number(event && event.detail && event.detail.cartCount);
    if (!Number.isFinite(count) || count < 0) return;
    document.querySelectorAll('a[href$="/cart"], a[href*="/cart?"]').forEach(function(link){
      if (!link.querySelector('cart-count, [data-cart-count]')) return;
      link.setAttribute('aria-label', 'Carrinho com ' + count + (count === 1 ? ' item' : ' itens'));
    });
  }

  function incrementVisibleCartCount(form){
    var countNode = document.querySelector('cart-count');
    if (!countNode) return;
    var currentCount = Number(countNode.getAttribute('data-cart-count') || countNode.textContent);
    var quantityInput = form.querySelector('[name="quantity"]');
    var quantity = Number(quantityInput && quantityInput.value) || 1;
    if (!Number.isFinite(currentCount) || currentCount < 0) return;
    document.dispatchEvent(new CustomEvent('theme:cart:change', {
      bubbles: true,
      detail: { cartCount: currentCount + Math.max(1, quantity) }
    }));
  }

  function initCard(card){
    if (!card || card.dataset.avCard11Ready === 'true') return;
    card.dataset.avCard11Ready = 'true';
    observeCard(card);

    var details = card.querySelector('[data-av-card-details]');
    if (details) {
      details.addEventListener('toggle', function(){
        if (details.open) emit('details_expanded', card, { disclosure: 'card_details' });
      });
    }

    card.addEventListener('click', function(event){
      var link = event.target.closest('a[href]');
      if (!link || link.classList.contains('av-card11__button--disabled')) return;
      var interaction = link.classList.contains('av-card11__media') ? 'media' : 'link';
      emit('product_card_clicked', card, { action: interaction });
      emit('au_product_card_click', card, { action: interaction, interaction_type: interaction });
    });

    var primaryImage = card.querySelector('.av-card11__image--primary');
    var thumbs = card.querySelectorAll('[data-av-card11-thumb]');
    if (primaryImage && thumbs.length) {
      thumbs.forEach(function(thumb){
        var update = function(){
          var src = thumb.getAttribute('data-image');
          if (!src) return;
          primaryImage.removeAttribute('srcset');
          primaryImage.src = src;
          thumbs.forEach(function(item){ item.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        };
        thumb.addEventListener('mouseenter', update);
        thumb.addEventListener('focus', update);
        thumb.addEventListener('click', function(event){ event.preventDefault(); update(); });
      });
    }

    var form = card.querySelector('.av-card11__form');
    if (!form || !window.fetch || !window.FormData) return;

    form.addEventListener('submit', function(event){
      event.preventDefault();
      var button = form.querySelector('[data-av-card11-submit]');
      var label = form.querySelector('[data-av-card11-button-text]');
      var defaultText = button ? button.getAttribute('data-default-text') : '';
      if (!defaultText && label) defaultText = label.textContent;
      var sharedCart = window.avMotion && window.avMotion.cart;
      if (sharedCart && typeof sharedCart.begin === 'function') {
        sharedCart.begin(button, form);
      } else if (button) {
        button.classList.add('is-loading');
        button.disabled = true;
      }
      if (!sharedCart && label) label.textContent = 'Adicionando';

      fetch(getRoot() + 'cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin'
      })
      .then(function(response){
        return response.json().then(function(data){
          if (!response.ok) {
            var error = new Error(data.description || data.message || 'Não foi possível adicionar o produto.');
            error.cartMessage = data.description || data.message;
            throw error;
          }
          return data;
        });
      })
      .then(function(item){
        if (sharedCart && typeof sharedCart.success === 'function') {
          sharedCart.success(button);
        } else if (button) {
          button.classList.remove('is-loading');
          button.classList.add('is-added');
          button.disabled = false;
        }
        if (!sharedCart && label) label.textContent = 'Adicionado';
        document.dispatchEvent(new CustomEvent('av:cart:add', { detail: { item: item, productId: card.getAttribute('data-product-id') } }));
        emit('au_product_card_quick_add', card, {
          variant_id: item && (item.variant_id || item.id),
          interaction_type: 'quick_add_success'
        });
        incrementVisibleCartCount(form);
        document.dispatchEvent(new CustomEvent('theme:cart:refresh'));
        window.setTimeout(function(){
          if (button) button.classList.remove('is-added');
          if (label && defaultText) label.textContent = defaultText;
        }, 1800);
      })
      .catch(function(error){
        if (sharedCart && typeof sharedCart.error === 'function') {
          sharedCart.error(button, error && error.cartMessage);
        } else if (button) {
          button.classList.remove('is-loading');
          button.disabled = false;
        }
        if (!sharedCart && label && defaultText) label.textContent = defaultText;
        emit('product_card_add_error', card, { action: 'quick_add' });
      });
    });
  }

  function initAll(context){
    (context || document).querySelectorAll('[data-av-card11]').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('theme:cart:change', syncCartAccessibleName);
  document.addEventListener('shopify:section:load', function(event){ initAll(event.target); });
})();
